import React from 'react'
import {Icon} from '@chakra-ui/react'

const WarrantyReturnIcon = (props) => {
    return (
        <Icon
            viewBox="0 0 20 20"
            width="20px"
            height="20px"
            aspectRatio="1/1"
            fill="none"
            aria-hidden="true"
            {...props}
        >
            <path
                d="M16.3713 11.1973V13.8941C16.3716 14.1961 16.2891 14.4924 16.1328 14.7507C15.9765 15.0089 15.7525 15.2192 15.4851 15.3585L10.6949 17.8232C10.4754 17.9375 10.2317 17.9972 9.98438 17.9972"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.098 7.4687L7.2382 2.17922C7.01569 2.06082 6.76761 1.9989 6.51568 1.9989C6.26376 1.9989 6.01568 2.06082 5.79316 2.17922L2.87914 3.69965C2.6164 3.84397 2.39659 4.05561 2.24216 4.31295C2.08773 4.57029 2.00421 4.86411 2.00016 5.16439C1.9961 5.46467 2.07163 5.76065 2.21905 6.02209C2.36647 6.28353 2.58048 6.50107 2.83923 6.65247L12.5952 12.198C12.8322 12.3297 13.0987 12.3989 13.3696 12.3989C13.6406 12.3989 13.9071 12.3297 14.144 12.198L17.1698 10.4055C17.4232 10.2503 17.6314 10.031 17.7735 9.76959C17.9156 9.50819 17.9866 9.21392 17.9793 8.91633C17.972 8.61874 17.8868 8.32831 17.7321 8.07421C17.5774 7.8201 17.3587 7.61128 17.098 7.4687Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.35255 8.17083L12.7305 2.1791C12.953 2.06069 13.2011 1.99878 13.453 1.99878C13.705 1.99878 13.953 2.06069 14.1756 2.1791L17.0896 3.69952C17.3544 3.8402 17.5773 4.04886 17.7353 4.30416C17.8933 4.55946 17.9809 4.85225 17.989 5.15259C17.9971 5.45293 17.9255 5.75004 17.7815 6.01355C17.6375 6.27705 17.4263 6.4975 17.1694 6.65235L2.35254 15.2069"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.98438 17.9988V10.7968"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.7168 8.90894L2.35296 11.4284"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                opacity="0.1"
                d="M15.5684 3.4541L6.49828 8.69072"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M7.26172 16.0981L5.0798 17.3579"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                opacity="0.1"
                d="M11.7354 13.9273L10.3171 14.7397"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </Icon>
    )
}

export default WarrantyReturnIcon
